import { render, staticRenderFns } from "./LegendView.vue?vue&type=template&id=97222e66&scoped=true&"
import script from "./LegendView.vue?vue&type=script&lang=js&"
export * from "./LegendView.vue?vue&type=script&lang=js&"
import style0 from "./LegendView.vue?vue&type=style&index=0&id=97222e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97222e66",
  null
  
)

export default component.exports